module.exports = __webpack_public_path__ + "static/media/duffey-2.07cac064.jpg";